<script>
	import {Link} from 'yrv';
</script>

<nav class="fixed items-center justify-between flex-wrap bg-teal-500 p-6 w-full">
  <div class="flex items-center flex-shrink-0 text-white mr-6">
    <span class="font-semibold text-xl tracking-tight"><Link href="/"><img class = "logo" src="logo.png" alt="Infomigra">Infomigra</Link></span>
  </div>
</nav>
